import { render } from "./external-data-confirm.vue?vue&type=template&id=5ca3fdf8&scoped=true"
import script from "./external-data-confirm.vue?vue&type=script&lang=js"
export * from "./external-data-confirm.vue?vue&type=script&lang=js"

import "./external-data-confirm.vue?vue&type=style&index=0&id=5ca3fdf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3fdf8"]])

export default __exports__